import { CallEventHandler, CallEventMap, CallEventName } from './types';

/**
 * Typed pub/sub for call pipeline events. One CallEventBus per pipeline instance
 * (created inside useCallPipeline). Consumers subscribe via on(); the Twilio
 * wrapper and state machine emit().
 */
export class CallEventBus {
	private readonly target = new EventTarget();

	public on<K extends CallEventName>(event: K, handler: CallEventHandler<K>): () => void {
		const wrapper = (e: Event) => handler((e as CustomEvent<CallEventMap[K]>).detail);
		this.target.addEventListener(event, wrapper);
		return () => this.target.removeEventListener(event, wrapper);
	}

	public emit<K extends CallEventName>(event: K, payload?: CallEventMap[K]): void {
		this.target.dispatchEvent(new CustomEvent(event, { detail: payload }));
	}
}
